import { useContext, useEffect, useState } from "react";
import SideChatFeed from "../components/SideChatFeed";
import { ChatContext } from "../context/ChatContext";
import { useLoading } from "../context/LoaderContext";
import AvatarsCarousel from "../components/AvatarsCarousel"; 
import AsyncLocalStorage from '@createnextapp/async-local-storage';
import DashboardHome from "./DashboardHome";
import MessagesDashboard from "./MessagesDashboard";
import socket from "../services/socket";

const Dashboard = ({ channelIdFromHome, accountDataVersionFromHome }) => { // Receive props
  const { setLoading } = useLoading(); 
  const [users, setUsers] = useState([]);   
  const { data, dispatch } = useContext(ChatContext);
  const [people, setPeople] = useState(data.activeChats);  
  const [currentChat, setCurrentChat] = useState(data.currentChat);  
 
  //console.log(`Dashboard.jsx RENDERING: channelId (prop)=${channelIdFromHome}, accountDataVersion (prop)=${accountDataVersionFromHome}, context.isAccountDataLoading=${data.isAccountDataLoading}, context.accountData is ${data.accountData ? "populated" : "null"}`);

  useEffect(() => { 
    setPeople(data.activeChats);
    setCurrentChat(data.currentChat);
  }, [data.activeChats, data.currentChat]); // Only include dependencies that this effect truly needs for its direct logic

 
  const HandleSelect = async (chat) => {    
     let client_id = await AsyncLocalStorage.getItem("silu-ClientId");
      if (client_id) { 
        socket.emit("set-channel", {clientId: client_id, channelId: chat.channel_id} );
      }   
      
      dispatch({ type: "CHANGE_CHAT", payload: chat.channel_id });
      dispatch({ type: "SET_CATEGORY", payload: chat.category });
      dispatch({ type: "SET_CHAT", payload: chat }); 
      setCurrentChat(chat);
      // Then reset the view, which will use the new accountNo to decide on loading
      dispatch({ type: "RESET_ACCOUNT_VIEW" }); 
  };  

  return (
    <main className="flex flex-1 min-h-screen bg-gradient-to-br from-sky-100 via-white to-neutral-200">
     <aside className="md:order-first lg:order-first lg:block lg:flex-shrink-0 bg-sidebar border-r border-gray-200 shadow-lg">
        <div className="relative flex h-full w-full md:w-96 flex-col overflow-y-auto">
         <div className="p-4"> {/* Standardized padding around the carousel */}
            <AvatarsCarousel people={people} handleSelect={HandleSelect} currentChat={currentChat} />
          </div>
          <SideChatFeed users={users} />
        </div>
      </aside>
      {channelIdFromHome == "null" ? <DashboardHome /> :  <MessagesDashboard />}
    </main>
  );
};

export default Dashboard;
